<template>
<el-dialog :show-close="false" top="4vh" :visible="true" width="80%" title="请确认本次开票的张数与明细">
<div class="detail">
  <span>发票张数：{{data.length}}张</span>
  <div>
    <span>未税金额总计：{{totalUnTaxedAmount | seperateThousandsToFixed(2)}}</span>
    <span style="margin-left: 12px">税额总计：{{totalTaxAmount | seperateThousandsToFixed(2)}}</span>
    <span style="margin-left: 12px">价税合计总计：{{totalAmount | seperateThousandsToFixed(2)}}</span>
  </div>
</div>
<div class="list">
  <div v-for="(item, index) in data" :key="index">
    <!-- 标题部分 -->
    <el-row :gutter="20" style="margin-top: 12px" type="flex" justify="center" align="middle">
      <el-col :span="2">
        <span>张次</span>
      </el-col>
      <el-col :span="2">
        <span>规格型号</span>
      </el-col>
      <el-col :span="2">
        <span>单位</span>
      </el-col>
      <el-col :span="2">
        <span>数量</span>
      </el-col>
      <el-col :span="4">
        <span>开票名称</span>
      </el-col>
      <el-col :span="2">
        <span>未税金额</span>
      </el-col>
      <el-col :span="2">
        <span>税率</span>
      </el-col>
      <el-col :span="2">
        <span>税额</span>
      </el-col>
      <el-col :span="2">
        <span>价税合计</span>
      </el-col>
      <el-col :span="4">
        <el-button v-if="data.length !== 1" type="danger" size="mini" @click="onRemove(index)">删除</el-button>
        <el-button v-if="index === data.length - 1" type="primary" size="mini" @click="onAdd">添加</el-button>
      </el-col>
    </el-row>
    <!-- 数据 -->
    <el-row :gutter="20" style="margin-top: 6px" type="flex" justify="center" align="middle" v-for="(subItem, idx) in item" :key="idx">
      <!-- 张次 -->
      <el-col :span="2">
        <span>{{index + 1}}</span>
      </el-col>
      <!-- 规格型号 -->
      <el-col :span="2">
        <el-input v-model="subItem.spec" size="small"></el-input>
      </el-col>
      <!-- 单位 -->
      <el-col :span="2">
        <el-input v-model="subItem.unit" size="small"></el-input>
      </el-col>
      <!-- 数量 -->
      <el-col :span="2">
        <el-input v-model="subItem.quantity" size="small"></el-input>
      </el-col>
      <!-- 开票名称 -->
      <el-col :span="4">
        <el-select v-model="subItem.invoice_name_id"
                   size="small"
                   placeholder="请选择"
                   @change="value => handleInvoiceTypeChange(value, subItem)">
          <el-option
            v-for="(value, key) in invoiceOptions"
            :key="key"
            :label="value.name"
            :value="Number(key)">
          </el-option>
        </el-select>
      </el-col>
      <!-- 未税金额 -->
      <el-col :span="2">
        <el-input v-if="invoiceTaxType === 2" v-model="subItem.no_tax_amount" @input="calWithTaxAmount(subItem)"></el-input>
        <span v-else>{{subItem.no_tax_amount | seperateThousandsToFixed(2)}}</span>
      </el-col>
      <!-- 税率 -->
      <el-col :span="2">
        <span>{{ subItem.tax_rate }}</span>
      </el-col>
      <!-- 税额 -->
      <el-col :span="2">
        <span>{{ subItem.tax_amount }}</span>
      </el-col>
      <!-- 价税合计 -->
      <el-col :span="2">
        <el-input v-if="invoiceTaxType === 1" v-model="subItem.with_tax_amount" @input="calNoTaxAmount(subItem)"></el-input>
        <span v-else>{{subItem.with_tax_amount | seperateThousandsToFixed(2)}}</span>
      </el-col>
      <!-- 添加 -->
      <el-col :span="4">
        <i style="font-size: 24px; color: #409EFF; cursor: pointer;" class="el-icon-circle-plus-outline point" @click="onSubAdd(index)"></i>
        <i v-if="item.length !== 1" style="font-size: 24px; color: #F56C6C; cursor: pointer;" class="el-icon-remove-outline" @click="onSubRemove(index, idx)"></i>
        <el-tooltip v-if="showTip(subItem)" class="item" effect="dark" content="单张发票的价税合计金额不得超过10W，请调整金额！" placement="top">
          <i class="el-icon-warning" style="font-size: 24px; color: #F56C6C; cursor: pointer;"></i>
        </el-tooltip>
      </el-col>
    </el-row>
  </div>
</div>
<div class="actions">
  <el-button @click="onCancel">取消</el-button>
  <el-button type="primary" @click="onSave">保存</el-button>
</div>
</el-dialog>
</template>

<script>
import TicketSplit, { RMB } from './index'

export default {
  props: {
    dataSource: {
      type: Array,
      default: () => [],
    },
    // 1 含税  2 未税
    invoiceTaxType: {
      type: Number,
      default: 0,
    },
  },
  data () {
    return {
      data: [],
    }
  },
  computed: {
    invoiceOptions () {
      return this.dataSource.reduce((total, current) => {
        if (!total[current.invoice_name_id]) {
          total[current.invoice_name_id] = {
            name: current.invoice_full_name,
            taxRate: current.tax_rate,
          }
        }
        return total
      }, {})
    },
    totalUnTaxedAmount () {
      return this.data.flat().reduce((total, current) => {
        return RMB(total).add(current.no_tax_amount)
      }, 0).value || 0
    },
    totalTaxAmount () {
      return this.data.flat().reduce((total, current) => {
        return RMB(total).add(current.tax_amount)
      }, 0).value || 0
    },
    totalAmount () {
      return this.data.flat().reduce((total, current) => {
        return RMB(total).add(current.with_tax_amount)
      }, 0).value || 0
    },
  },
  watch: {
    dataSource: {
      immediate: true,
      handler (newValue, oldValue) {
        const tmp = this.transformation()
        this.data = tmp.map(items => {
          return items.map(item => {
            item.with_tax_amount = item.total
            this.calNoTaxAmount(item)
            // if (this.invoiceTaxType === 1) {
            //   item.with_tax_amount = item.total
            //   this.calNoTaxAmount(item)
            // } else {
            //   item.no_tax_amount = item.untaxed_amount
            //   item.with_tax_amount = item.total
            //   // this.calWithTaxAmount(item)
            // }
            return item
          })
        })
      }
    }
  },
  methods: {
    transformation () {
      let limitKey = 'total'
      // if (this.invoiceTaxType === 2) {
      //   limitKey = 'untaxed_amount'
      // }
      const ticketSplit = new TicketSplit(this.dataSource, limitKey, ['spec', 'unit', 'quantity', 'invoice_name_id'])
      return ticketSplit.transformation()
    },
    calNoTaxAmount (item) {
      item.no_tax_amount = RMB(item.with_tax_amount).divide(RMB(1).add(item.tax_rate * 0.01)).value
      item.tax_amount = RMB(item.with_tax_amount).subtract(item.no_tax_amount)
    },
    calWithTaxAmount (item) {
      item.with_tax_amount = RMB(item.no_tax_amount).multiply(RMB(1).add(item.tax_rate * 0.01)).value
      item.tax_amount = RMB(item.with_tax_amount).subtract(item.no_tax_amount)
    },
    handleInvoiceTypeChange (value, item) {
      item.tax_rate = this.invoiceOptions[value].taxRate
      if (this.invoiceTaxType === 1) {
        this.calNoTaxAmount(item)
      } else {
        this.calWithTaxAmount(item)
      }
    },
    getForm () {
      this.data.forEach((items, index) => {
        items.forEach((item, idx) => {
          if (!item.invoice_name_id) {
            throw Error(`张次${index + 1}中的条目${idx + 1}未选择开票名称`)
          }
          if (this.invoiceTaxType === 1 && item.with_tax_amount.length === 0) {
            throw Error(`张次${index + 1}中的条目${idx + 1}未输入价税合计`)
          }
          if (this.invoiceTaxType === 2 && item.no_tax_amount.length === 0) {
            throw Error(`张次${index + 1}中的条目${idx + 1}未输入未税金额`)
          }
        })
      })
      return JSON.parse(JSON.stringify(this.data))
    },
    onCancel () {
      this.$emit('onClose')
    },
    onSave () {
      try {
        this.$emit('onSave', this.getForm())
      } catch (error) {
        this.$message.error(error.message)
      }
    },
    onRemove (index) {
      this.data.splice(index, 1)
    },
    onAdd () {
      this.data.push([
        {
          'spec': '', // 规格型号
          'unit': '', // 单位
          'quantity': '', // 数量，未填写请传 0
          'invoice_name_id': '', // 开票名称 id
          'no_tax_amount': '', // 未税金额
          'with_tax_amount': '', // 含税金额
          'tax_amount': '', // 税额
          'tax_rate': '' // 税率，取数据库开票名称的配置值
        }
      ])
    },
    onSubAdd (index) {
      const tmp = this.data[index][0]
      this.data[index].push(
        {
          ...tmp,
        }
      )
    },
    onSubRemove (index, idx) {
      this.data[index].splice(idx, 1)
    },
    showTip (item) {
      if (this.invoiceTaxType === 2) {
        return RMB(item.no_tax_amount).multiply(RMB(1).add(RMB(item.tax_rate).multiply(0.01))).value !== item.with_tax_amount
      }
      return false
    },
  }
}
</script>

<style lang="scss">
// 全局CSS
</style>
<style lang="scss"
       scoped>
.detail {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  font-size: 16px;
  margin-bottom: 12px;
}
.list {
  height: 54vh;
  border: 12px solid #dcdfe6;
  padding: 12px;
  overflow: scroll;
}
.actions {
  margin-top: 12px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}
// 带作用域的CSS
// https://vue-loader.vuejs.org/zh-cn/features/scoped-css.html
</style>
<style lang="scss"
       module>
// 带作用域的CSS
// 绑定class方式 <p :class="$style.red"></p>
// https://vue-loader.vuejs.org/zh-cn/features/css-modules.html
</style>



// WEBPACK FOOTER //
// src/views/invoice-apply/components/ticket-split/InvoiceTicketSplit.vue